
import { DOCUMENT, Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UniversalWrapperService {
  private _doc = inject<Document>(DOCUMENT);


  getWindow(): Window | null {
    return this._doc.defaultView;
  }

  getLocation(): Location {
    return this._doc.location;
  }
}
